<template>
  <div class="fab-container">
    <div class="dragBoxIcon">
      <v-icon class="icon" name="arrows-alt" scale="1"></v-icon>
    </div>
    <div class="optionsBoxIcon" v-on:click="showFAB(index)">
      <v-icon class="icon" name="chevron-down" scale="1"></v-icon>
    </div>
    <div class="boxOptions" v-if="activeFABIndex == index && optionsActive">
      <div
        class="infoTooltip dropdown-item"
        v-if="box.type === 'voucher' && box.counter != 0"
      >
        <v-icon class="icon" name="pencil-alt" scale="1"></v-icon>
        <p>
          The voucher cannot be edited since it is already in use by your
          guests.
        </p>
      </div>
      <div
        class="editBoxIcon dropdown-item"
        v-if="
          box.type !== 'voucher' || (box.type == 'voucher' && box.counter === 0)
        "
        v-on:click="showEditModal"
      >
        <v-icon class="icon" name="pencil-alt" scale="1"></v-icon>
      </div>
      <div
        class="visibilityBoxIcon dropdown-item"
        v-on:click="boxVisibility(false)"
        v-if="isBoxVisible(box.visibility)"
      >
        <v-icon class="icon" name="eye" scale="1.3"></v-icon>
      </div>
      <div
        class="visibilityBoxIcon dropdown-item"
        v-on:click="boxVisibility(true)"
        v-else
      >
        <v-icon class="icon" name="eye-slash" scale="1.3"></v-icon>
      </div>
      <div
        class="copyBoxIcon dropdown-item"
        v-if="box.type != 'voucher' && box.type != 'form'"
        v-on:click="copyBox(box, index)"
      >
        <v-icon class="icon" name="clone" scale="1"></v-icon>
      </div>
      <div class="deleteBoxIcon dropdown-item" v-on:click="showDeleteModal">
        <v-icon class="icon" name="regular/trash-alt" scale="1"></v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";

export default {
  props: {
    box: Object,
    index: Number,
    activeFABIndex: Number,
    computedBoxesData: Array,
  },
  data() {
    return {
      optionsActive: false,
    };
  },
  watch: {
    activeFABIndex(newValue) {
      this.optionsActive = this.index !== newValue ? false : true;
    },
  },
  methods: {
    showFAB(boxIndex) {
      this.optionsActive = !this.optionsActive;
      this.$emit("passActiveIndex", boxIndex);
    },
    showEditModal() {
      this.$emit("showEditModal");
    },
    showDeleteModal() {
      this.$emit("showDeleteModal");
    },
    boxVisibility(makeVisible) {
      if (makeVisible) {
        this.$emit("editVisibility", { precheckin: true, checkin: true, anonymous: true });
      } else {
        this.$emit("editVisibility", { precheckin: false, checkin: false, anonymous: false });
      }
    },
    isBoxVisible(visibility) {
      return visibility.anonymous;
    },
    copyBox(box, boxIndex) {
      var newObjToFirebase = this.computedBoxesData;
      newObjToFirebase.splice(boxIndex, 0, box);
      this.$toastEvents.push({
        type: "positive",
        title: "Success",
        content: "The box has been copied",
        id: +new Date(),
      });
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(newObjToFirebase);
    },
  },
};
</script>

<style scoped>
.icon {
  margin: auto;
}

.dragBoxIcon,
.optionsBoxIcon,
.visibilityBoxIcon,
.editBoxIcon,
.copyBoxIcon,
.deleteBoxIcon,
.infoTooltip {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  background-color: #3f3d39;
  color: #fff;
  top: -5px;
  right: -5px;
  z-index: 20;
  min-height: 0px;
}
.dragBoxIcon {
  right: 40px;
}

.editBoxIcon,
.visibilityBoxIcon,
.copyBoxIcon,
.deleteBoxIcon {
  background-color: #62738b;
}
.dropdown-item:nth-child(1) {
  top: 45px;
}
.dropdown-item:nth-child(2) {
  top: 95px;
}
.dropdown-item:nth-child(3) {
  top: 145px;
}
.dropdown-item:nth-child(4) {
  top: 195px;
}

.infoTooltip {
  background-color: rgba(0, 0, 0, 0.4);
}
.dragBoxIcon:hover {
  cursor: move;
}
.infoTooltip:hover p {
  display: block;
}

.infoTooltip p {
  /* The tooltip */
  display: none;
  text-align: center;
  background-image: linear-gradient(
    to right,
    rgba(72, 185, 186, 1),
    rgba(137, 78, 153, 1)
  );
  padding: 30px 20px;
  width: 320px;
  position: absolute;
  border-radius: 8px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  right: 45px;
  top: 5px;
  margin-top: -30px;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.4;
}

.infoTooltip p:after {
  /* Prevents the tooltip from being hidden */
  width: 100%;
  height: 40px;
  content: "";
  position: absolute;
  top: -40px;
  left: 0;
}

/* @media (max-width: 680px) {
  .dragBoxIcon {
    right: 65px;
  }
  .optionsBoxIcon,
  .editBoxIcon,
  .visibilityBoxIcon,
  .copyBoxIcon,
  .deleteBoxIcon,
  .infoTooltip {
    right: 20px;
  }

} */
</style>
